import SignInForm from 'components/modules/auth/SignInForm';
import AuthSimpleLayout from 'layouts/AuthSimpleLayout';

const SignInPage = () => {
  return (
    <AuthSimpleLayout>
      <SignInForm />
    </AuthSimpleLayout>
  );
};

export default SignInPage;
